import { render, staticRenderFns } from "./productProfitFactory.vue?vue&type=template&id=7099f710"
import script from "./productProfitFactory.vue?vue&type=script&lang=js"
export * from "./productProfitFactory.vue?vue&type=script&lang=js"
import style0 from "./productProfitFactory.vue?vue&type=style&index=0&id=7099f710&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports